/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useState, useEffect } from "react";
import { useNotification } from "context/NotificationContext";
// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MDBox from "components/MDBox";

import expedientesService from "../../services/expedientesService";
import MDBadge from "components/MDBadge";

function colorIdentifier(state) {
  let color;
  switch (state.toUpperCase()) {
    case "NUEVO":
      color = "error";
      break;
    case "INFORME EN PROCESO":
      color = "info";
      break;
    case "INFORME ENVIADO":
      color = "info";
      break;
    case state.toUpperCase().match("INTIMACIÓN")?.input:
      color = "primary";
      break;
    case "SENTENCIA":
      color = "success";
      break;
    case "COBRADO":
      color = "success";
      break;
    default:
      color = "warning";
      break;
  }
  return color;
}

function FileState(props) {
  const { id, state } = props;
  if (id == null && state == null) {
    return null;
  }
  const { showNotification } = useNotification();
  const [intState, setIntState] = useState(state);
  const [menu, setMenu] = useState(null);
  const [color, setColor] = useState("info");

  const openMenu = (currentTarget) => {
    setMenu(currentTarget);
  };

  const closeMenu = () => {
    setMenu(null);
  };

  const handleUpdate = async (newState) => {
    closeMenu();
    const expediente = {
      id,
      state: newState,
    };

    const data = await expedientesService.updateState(expediente);
    if (data.error) {
      showNotification(data.message, "error");
    } else {
      setIntState(newState);
      setColor(colorIdentifier(newState));
      showNotification("Registro actualizado correctamente", "success");
    }
  };

  useEffect(() => {
    setIntState(state);
    setColor(colorIdentifier(state));
  }, [id, state]);

  const renderMenu = (
    <Menu
      id="simple-menu"
      anchorEl={menu}
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={Boolean(menu)}
      onClose={closeMenu}
    >
      <MenuItem onClick={() => handleUpdate("Nuevo")}>Nuevo</MenuItem>
      <MenuItem onClick={() => handleUpdate("En revisión")}>En revisión</MenuItem>
      <MenuItem onClick={() => handleUpdate("Cargo aceptado")}>Cargo aceptado</MenuItem>
      <MenuItem onClick={() => handleUpdate("Pericia propuesta")}>Pericia propuesta</MenuItem>
      <MenuItem onClick={() => handleUpdate("Pericia acordada")}>Pericia acordada</MenuItem>
      <MenuItem onClick={() => handleUpdate("Informe en proceso")}>Informe en proceso</MenuItem>
      <MenuItem onClick={() => handleUpdate("Informe enviado")}>Informe enviado</MenuItem>
      <MenuItem onClick={() => handleUpdate("Intimación actora")}>Intimación actora</MenuItem>
      <MenuItem onClick={() => handleUpdate("Intimación demandada")}>Intimación demandada</MenuItem>
      <MenuItem onClick={() => handleUpdate("Cargo destituido")}>Cargo destituido</MenuItem>
      <MenuItem onClick={() => handleUpdate("Solicitud impugnación")}>
        Solicitud impugnación
      </MenuItem>
      <MenuItem onClick={() => handleUpdate("Pericia desistida")}>Pericia desistida</MenuItem>
      <MenuItem onClick={() => handleUpdate("Apelación")}>Apelación</MenuItem>
      <MenuItem onClick={() => handleUpdate("Sentencia")}>Sentencia</MenuItem>
      <MenuItem onClick={() => handleUpdate("Cobrado")}>Cobrado</MenuItem>
    </Menu>
  );

  return (
    <MDBox>
      <MDBadge
        badgeContent={intState + " ▾"}
        size="xs"
        container
        color={color}
        onClick={(e) => openMenu(e.currentTarget)}
        sx={{ cursor: "pointer" }}
      />
      {renderMenu}
    </MDBox>
  );
}

FileState.propTypes = {
  id: PropTypes.number.isRequired,
  state: PropTypes.string.isRequired,
};

export default FileState;
